import { useMutation } from "@tanstack/react-query";
import type { CustomRiskRequestInput } from "@unbox/api";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "../scoped-merchant-client";

export const useCreateCustomRiskRequest = () => {
  const scope = useScopedMerchantClient();

  return useMutation({
    mutationFn: async (input: CustomRiskRequestInput) => {
      if (!scope.merchantId) throw new Error("No merchant selected");

      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].safety["custom-risk-request"].$post({
            param: scope.param,
            json: input,
          })
        : await client.merchant[":merchantId"].safety["custom-risk-request"].$post({
            param: scope.param,
            json: input,
          });

      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
